export default __webpack_public_path__ + "static/media/sie-logo-white.bbf10b1d.svg";